module.exports = __webpack_public_path__ + "img/icon-home.2de8a7d2.svg";